// extracted by mini-css-extract-plugin
export default {"button":"Jj-z","reviewSort":"Kj-z"};